<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div style="width:100%" v-show="premise != null">
        <v-toolbar flat color="green" class="p-1">
            <v-toolbar-title>Profiles</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="addProfile()">
                Add Profile
                <v-icon right dark>create</v-icon>
            </v-btn>
        </v-toolbar>
        <v-data-table :headers="headers"
                      :items="profiles"
                      class="elevation-1"
                      :pagination.sync="pagination"
                      :total-items="totalRecords">
            <template v-slot:items="props">
                <td>{{props.item.name}}</td>
                <td>

                    <v-btn icon  v-on:click="editProfile(props.item.id)">
                        <v-icon>create</v-icon>
                    </v-btn>
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import api from '@/api';
    export default {
        inject : ['premisePromise'],
        data() {
            return {
                headers: [
                    {text: 'Name', value: 'name'},
                    {text: 'Actions', value:''}
                ],
                profiles: [],
                totalRecords: null,
                pagination: {
                    rowsPerPage: 25,
                    page: 1
                },
                filter: {
                    name: null
                },
                premise: {}
            }
        },
        mounted() {
            this.premisePromise().then(prem => {
                this.premise = prem;
                this.searchProfiles();
            });
        },
        watch: {
            pagination: {
                handler () {
                    if (this.premise && this.premise.id) {
                        this.searchProfiles();
                    }
                },
                deep: true
            }
        },
        methods : {
            editProfile(id) {
                this.$router.push({'path':"/profile/"+id});
            },
            addProfile() {
                this.$router.push({name:'CreateProfile',params:{premiseId:this.premise.id}});
            },
            searchProfiles () {
                api.profile.search({
                    premiseId:this.premise.id,
                    pageNumber: this.pagination.page-1,
                    pageSize: this.pagination.rowsPerPage,
                    sortBy : this.pagination.sortBy,
                    sortOrder : this.pagination.descending ? 'DESC' : 'ASC'
                }).then(data => {
                    this.profiles = data.list;
                    this.totalRecords = data.totalRecords;
                });
            },
        }

    }


</script>